import { OrderReceiptModel } from '@/models/OrderReceiptModel';

export interface OrderState {
  orderReceipt: OrderReceiptModel | null;
}

const state: OrderState = {
  orderReceipt: null,
};

export default state;
